import AddFloorPlan from './FloorPlan.vue'
import EditBuildingInformation from './EditBuildingInformation.vue'
import EditBuildingAccessCode from './EditBuildingAccessCode.vue'
let routers = [
  {
    name: 'building-floor-plan',
    path: 'floor-plan',
    component: AddFloorPlan
  },
  {
    name: 'edit-building-access-code',
    path: 'edit-building-access-code',
    component: EditBuildingAccessCode
  },
]

export { routers }